var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeasing = function SvgLeasing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "leasing_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#leasing_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B1F",
    d: "M6.5 16q.624 0 1.063-.437Q8 15.125 8 14.5t-.437-1.062A1.45 1.45 0 0 0 6.5 13q-.625 0-1.062.438A1.45 1.45 0 0 0 5 14.5q0 .624.438 1.063Q5.874 16 6.5 16m9 0q.5 0 .9-.3t.525-.775a3.422 3.422 0 0 1-1.775-.95l-.625-.625a1.35 1.35 0 0 0-.388.5 1.5 1.5 0 0 0-.137.65q0 .624.438 1.063.437.437 1.062.437M2 12.35q0-.175.025-.35t.075-.325L4.1 6q.15-.45.538-.725Q5.025 5 5.5 5H8q.424 0 .713.287Q9 5.576 9 6q0 .424-.287.713A.97.97 0 0 1 8 7H5.85L4.8 10H11q.424 0 .713.287.287.288.287.713 0 .424-.287.713A.97.97 0 0 1 11 12H4v5h14v-1q0-.424.288-.713A.97.97 0 0 1 19 15q.424 0 .712.287.288.288.288.713v3.5q0 .625-.437 1.063A1.45 1.45 0 0 1 18.5 21q-.625 0-1.062-.437A1.45 1.45 0 0 1 17 19.5V19H5v.5q0 .625-.437 1.063A1.45 1.45 0 0 1 3.5 21q-.625 0-1.062-.437A1.45 1.45 0 0 1 2 19.5zM15 6q.424 0 .713-.287A.97.97 0 0 0 16 5a.97.97 0 0 0-.287-.713A.97.97 0 0 0 15 4a.97.97 0 0 0-.713.287A.97.97 0 0 0 14 5q0 .424.287.713Q14.576 6 15 6m1.55 6.55-5.1-5.1a1.6 1.6 0 0 1-.325-.487A1.5 1.5 0 0 1 11 6.375V2.5q0-.625.438-1.062A1.45 1.45 0 0 1 12.5 1h3.875q.3 0 .587.125.288.125.488.325l5.1 5.1q.425.425.425 1.063t-.425 1.062l-3.875 3.875a1.44 1.44 0 0 1-1.062.425q-.638 0-1.063-.425m1.075-1.75L20.8 7.625 16.175 3H13v3.175z"
  }))));
};
export default SvgLeasing;